<template>
  <v-bottom-sheet v-model="active" persistent>
    <div class="bottom-sheet-content">
      <div class="bottom-sheet-header">
        <span class="bottom-sheet-title">Editar observações da mídia</span>
        <v-btn v-if="!loading" icon @click="closeModal">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>

      <div class="mt-5">
        <v-textarea
          height="150px"
          v-model="form.observation"
          :disabled="loading"
          label="Observações"
          outlined
          hide-details
          style="width: calc(100% - 35px); float: left"
        ></v-textarea>
        <button
          v-if="status !== 'finished' && status !== 'canceled'"
          @click="recognitionVoice"
          :class="{ 'voice-recognition': true, recording: isRecognizing }"
          style="
            cursor: pointer;
            width: 30px;
            height: 150px;
            margin-left: 5px;
            text-align: center;
            border: 1px dashed rgba(0, 0, 0, 0.4);
            border-radius: 6px;
          "
        >
          <div :key="isRecognizing">
            <div v-if="isRecognizing">
              <v-icon size="28" color="#fff">mdi-microphone</v-icon>
              :media="modals.editMedia.media"
            </div>
            <div v-else>
              <v-icon size="28">mdi-microphone</v-icon>
            </div>
          </div>
        </button>
      </div>

      <RecognitionVoiceService v-if="speechToText.isRecognizing" @recognized-voice="handleSpeechRecognitionResult" @cancel="cancelRecognizeVoice" />

      <div v-if="form?.updated_by_user" class="mt-2 mb-4">
        <small
          >Alterado pela última vez por {{ handleObservation(media?.updated_by_user) }} em {{ new Date(media?.updated_at).toLocaleDateString() }} às
          {{ new Date(media?.updated_at).toLocaleTimeString() }}</small
        >
      </div>

      <v-switch v-model="form.visible" label="Mídia visível para o cliente" color="primary" :disabled="loading"></v-switch>
      <v-btn class="mt-2" color="primary" block @click="saveModal" elevation="0" :loading="loading">Salvar</v-btn>
    </div>
  </v-bottom-sheet>
</template>

<script>
import RecognitionVoiceService from '@/components/Common/RecognitionVoiceService';

export default {
  components: { RecognitionVoiceService },
  emits: ['close', 'save'],
  props: {
    isActive: {
      type: Boolean,
      required: true
    },
    media: {
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      active: false,
      isRecognizing: false,
      form: {
        observation: '',
        visible: false
      },
      speechToText: {
        target: null,
        recognition: null,
        isRecognizing: false
      }
    };
  },
  computed: {
    status() {
      return this.$store.getters['ServiceOrder/status'];
    }
  },
  watch: {
    isActive(newValue) {
      this.active = newValue;

      if (newValue) {
        this.form = {
          observation: this.media?.observation,
          visible: this.media?.visible ?? true
        };
      }
    }
  },
  methods: {
    cleanData() {
      this.form = {
        observation: '',
        visible: false
      };
      this.isRecognizing = false;
    },
    closeModal() {
      this.$emit('close');
    },
    saveModal() {
      this.$emit('save', this.form);
    },
    handleSpeechRecognitionResult(result) {
      if (!result || typeof result !== 'string') {
        this.cancelRecognizeVoice();
        return;
      }

      if (!this.form) {
        this.cancelRecognizeVoice();
        return;
      }

      if (this.form.observation === null || this.form.observation === undefined) {
        this.form.observation = '';
      } else if (this.form.observation.length > 0) {
        this.form.observation += '\n';
      }
      this.form.observation += result;
      this.cancelRecognizeVoice();
    },
    cancelRecognizeVoice() {
      this.speechToText = {
        target: null,
        recognition: null,
        isRecognizing: false
      };
    },
    recognitionVoice(target) {
      if (this.loading) {
        return;
      }

      this.speechToText.target = target;
      this.speechToText.isRecognizing = true;
    }
  }
};
</script>
